<template>
  <v-menu>
    <template #activator="{ props }">
      <v-btn
        class="content-nav-menu"
        size="default"
        color="#eeeeee"
        v-bind="props"
      >
        <v-icon icon="mdi-menu" />
      </v-btn>
    </template>

    <v-list>
      <v-list-item v-for="link in links" :key="link.to" :to="link.to">
        <v-list-item-title>{{ t(link.label) }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const links = [
  { to: '/sahkoinen-allekirjoitus', label: 'esign' },
  { to: '/sahkoinen-allekirjoitus-yrityksille', label: 'esignBusiness' },
  { to: '/sahkoinen-allekirjoitus-turvallisuus', label: 'esignSecurity' },
  { to: '/tyosopimuksen-sahkoinen-allekirjoitus', label: 'employmentContract' },
  { to: '/vuokrasopimuksen-sahkoinen-allekirjoitus', label: 'rentalContract' },
  { to: '/ukk', label: 'faq' },
  { to: '/hinnasto', label: 'pricing' },
];
</script>

<style scoped>
.content-nav-menu {
  position: absolute;
  top: 16px;
  right: 92px;
  z-index: 2;
  min-width: unset !important;
  padding: 0 12px !important;
  box-shadow:
    rgba(0, 0, 0, 0.15) 0px 15px 25px,
    rgba(0, 0, 0, 0.05) 0px 5px 10px;
}
</style>

<i18n lang="json">
{
  "fi": {
    "esign": "Sähköinen allekirjoitus",
    "esignBusiness": "Sähköinen allekirjoitus yrityksille",
    "esignSecurity": "Turvallisuus ja juridinen pätevyys",
    "employmentContract": "Työsopimuksen allekirjoitus",
    "rentalContract": "Vuokrasopimuksen allekirjoitus",
    "faq": "Usein kysytyt kysymykset",
    "pricing": "Hinnasto"
  },
  "en": {
    "esign": "Electronic signature",
    "esignBusiness": "Electronic signature for businesses",
    "esignSecurity": "Security and legal validity",
    "employmentContract": "Employment contract signing",
    "rentalContract": "Rental contract signing",
    "faq": "Frequently asked questions",
    "pricing": "Pricing"
  }
}
</i18n>
